import { View, Text } from '@react-pdf/renderer';
import { FunctionComponent } from 'react';

import pdfDocStyles from './pdfDocStyles';

const PdfSlider: FunctionComponent<{
  percent: number;
  label: string;
  value: string;
}> = ({ percent, label, value }) => (
  <>
    <View
      style={{
        position: 'relative',
        borderBottom: '1px solid #e8e8e8',
        marginBottom: 10,
        paddingRight: 15,
      }}
    >
      <View
        style={{
          position: 'absolute',
          bottom: 3,
          left: 0,
          width: 10,
          height: 10,
          backgroundColor: '#283237',
        }}
      />
      <View
        style={{
          position: 'relative',
          left: 15,
          bottom: 2,
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Text style={pdfDocStyles.sliderLabel}>{label}</Text>
        <Text style={pdfDocStyles.sliderLabel}>{value}</Text>
      </View>
    </View>
    <View style={{ position: 'relative', height: 20, width: '100%' }}>
      <View
        style={{ position: 'absolute', top: 7, bottom: 7, left: 10, right: 10 }}
      >
        <View
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#eeeeee',
            borderRadius: 3,
          }}
        />
        <View
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            width: `${percent}%`,
            backgroundColor: '#3182ce',
            borderRadius: 3,
          }}
        />
      </View>
      <View
        style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 20 }}
      >
        <View
          style={{
            position: 'absolute',
            left: `${percent}%`,
            width: 20,
            height: 20,
            backgroundColor: '#ffffff',
            border: '1px solid #cccccc',
            borderRadius: '100%',
          }}
        />
      </View>
    </View>
  </>
);

export default PdfSlider;
